import Styles from './CollapsibleSection.module.scss'
import { ReactNode, useState } from 'react'
import { Heading } from 'almanac-ui/Heading/Heading'
import { Text } from 'almanac-ui/Text/Text'
import Collapse from 'react-css-collapse'
import { Button } from 'blaze-ui/Button'
import { DirectionalChevron } from 'components/DirectionalChevron/DirectionalChevron'

interface Props {
  children: ReactNode
}

export const CollapsibleSection = ({ children }: Props) => {
  const [isOpen, setIsOpen] = useState<boolean>(false)

  const handleToggle = () => {
    setIsOpen((open) => !open)
  }

  return (
    <>
      <div className={Styles.divider} />
      <div className={Styles.collapsibleSection} onClick={handleToggle}>
        <div className={Styles.labels}>
          <Heading level={4}>More ways to configure</Heading>
          <Text variant="p2">Add more specific information to make your content better</Text>
        </div>
        <Button
          endIcon={() => <DirectionalChevron direction={isOpen ? 'up' : 'down'} />}
          size="lg"
          variant='secondary'
          onPress={handleToggle}
        >
          {isOpen ? 'Hide' : 'Show'}
        </Button>
      </div>
      <Collapse isOpen={isOpen} className={Styles.collapse}>
        <div className={Styles.padding} />
        {children}
      </Collapse>
    </>
  )
}
